/** @jsxImportSource @emotion/react */
'use memo'

import css from '@emotion/css/macro'
import { keyframes } from '@emotion/react'
import colors from '@sportninja/common/constants/appColors'

// SECONDARY_350 is absent from the typed appColors inference; read it via a
// cast, the established pattern in this feature.
const palette = colors as Record<string, string>

const ROW_COUNT = 3

/** Mirrors the family grid: a header bar and three rows. */
const FamilyMembersSkeleton = () => (
  <div css={wrapStyle} aria-hidden='true'>
    <div css={headerStyle} />
    {Array.from({ length: ROW_COUNT }).map((_, index) => (
      <div key={index} css={rowStyle} />
    ))}
  </div>
)

export default FamilyMembersSkeleton

// ---- styled ----
const pulse = keyframes`
  0% { opacity: 0.5; }
  50% { opacity: 0.9; }
  100% { opacity: 0.5; }
`

const bar = css`
  border-radius: 8px;
  background-color: ${palette.SECONDARY_350};
  animation: ${pulse} 1.4s ease-in-out infinite;
`

const wrapStyle = css`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`

const headerStyle = css`
  ${bar}
  height: 32px;
`

const rowStyle = css`
  ${bar}
  height: 40px;
`
